// config/apiConfig.js
// export const BASE_URL = "https://clantesting.quantapeople.com/clantestapi";

// export const BASE_URL = "http://localhost:8000";

// production
export const BASE_URL = "https://7cwa4vlcn5xpouehfdas3qrsha0kezza.lambda-url.ap-south-1.on.aws";

// staging
// export const BASE_URL = "https://jozc22oz7io7uu6whp4xipwet40jeswt.lambda-url.ap-south-1.on.aws"

// new staging
// export const BASE_URL = "https://y7jzowpxqk7htgruibiqwjp7ii0yugvu.lambda-url.ap-south-1.on.aws"

